import { useNavigate, useParams } from "@tanstack/react-router";

import { useFlowStepContext } from "@/lib/context/flow-step-context";

export const useSubStepNavigation = () => {
  const { stepId } = useParams({ strict: false });
  const navigate = useNavigate();
  const { step } = useFlowStepContext();

  const goToSubStep = (subStepId: string, options?: { replace?: boolean }): void => {
    void navigate({
      to: "/flows/$stepId/$subStepId",
      params: { stepId: String(stepId ?? step.codEtapa), subStepId },
      replace: options?.replace,
    });
  };

  return { goToSubStep };
};
